import React, { useContext } from 'react'
import { makeStyles } from '@material-ui/core/styles';
import { StoreContext } from '../../../../Store/Provider';
import clsx from 'clsx';
import Drawer from '@material-ui/core/Drawer';
import Sidebar from '../Sidebar/Sidebar';
import Header from '../Header/Header';
import './blog.css'


function BlogSFL() {
    const context = useContext(StoreContext);
    const classes = useStyles();
    return (
        <div className='home'>
            {/* <Header /> */}
            <div className='shipmentsListingHome' style={{ height: '100%' }}>
                <Drawer
                    variant="persistent"
                    className={clsx(classes.drawerLeft, {
                        [classes.drawerOpen]: context.menuBar,
                        [classes.drawerClose]: !context.menuBar,
                    })}
                    classes={{
                        paper: clsx(
                            classes.drawerPaperleft, {
                            [classes.drawerOpen]: context.menuBar,
                            [classes.drawerClose]: !context.menuBar,
                        }),
                    }}
                >
                    <Sidebar />
                </Drawer>
                <main
                    className={clsx(classes.content, {
                        [classes.contentwidth]: context.menuBar,
                        [classes.contentFullWidth]: !context.menuBar,
                    })}
                >
                    <div className='blogdetailsBody'>
                        <iframe src={'https://www.softfreightlogic.com/'} />
                    </div>
                </main>
            </div>
        </div>
    )
}

const useStyles = makeStyles((theme) => ({
    content: {
        flexGrow: 1,
        transition: theme.transitions.create('margin', {
            easing: theme.transitions.easing.sharp,
            duration: theme.transitions.duration.leavingScreen,
        }),
    },
    contentFullWidth: {
        width: 'calc(100% - 2.5rem)',
    },
    contentwidth: {
        width: 'calc(100% - 16rem)',
    },
    drawerLeft: {
        width: '16rem',
        flexShrink: 0,
        whiteSpace: 'nowrap',
    },
    drawerPaperleft: {
        top: 'auto',
        height: '100%',
        visibility: 'visible !important',
        transform: 'translateX(0px) !important'
    },
    drawerOpen: {
        width: '16rem',
        transition: theme.transitions.create('width', {
            easing: theme.transitions.easing.sharp,
            duration: theme.transitions.duration.enteringScreen,
        }),
    },
    drawerClose: {
        transition: theme.transitions.create('width', {
            easing: theme.transitions.easing.sharp,
            duration: theme.transitions.duration.leavingScreen,
        }),
        overflowX: 'hidden',
        width: '2.5rem',
    },
}));

export default BlogSFL
